import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_QUALIFICATIONS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_QUALIFICATION:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_QUALIFICATION:
      return { ...state, [action.payload.Id]: action.payload };
    case type.EDIT_QUALIFICATION:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_QUALIFICATION:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
